//@ts-nocheck
import { ShowAnswer, answerField, ShowSubmittedAnswer } from '../../../utilities/AnswerField';
import { ProgramQuestionInterface, SessionFeedbackAnswerInterface } from '../SessionFeedback';
import { Control, Controller, FieldErrors, FieldValues } from 'react-hook-form';
import _ from 'lodash';

export function questionField(
	programQuestion: ProgramQuestionInterface[],
	control: Control<FieldValues> | undefined,
	errors: FieldErrors<FieldValues>,
	programAnswer: SessionFeedbackAnswerInterface
) {
	return programQuestion.map((question: ProgramQuestionInterface, index: number) => {
		let feedback = null;
		if (!_.isEmpty(programAnswer.sessionFeedbackForm)) {
			feedback = programAnswer.sessionFeedbackForm.feedback.find((answer) => answer.question_id === question.id);
		}

		return (
			<div className="feedback-session-form-mobile min-w-0" key={question.id}>
				<Controller
					control={control}
					defaultValue={question.id}
					name={`feedback.${index}.question_id` as `${string}.${number}`}
					render={({ field }) => <input {...field} type="hidden" />}
				/>
				<Controller
					control={control}
					defaultValue={question.category}
					name={`feedback.${index}.question_category` as `${string}.${number}`}
					render={({ field }) => <input {...field} type="hidden" />}
				/>
				<Controller
					control={control}
					defaultValue={`${question.primary}`}
					name={`feedback.${index}.required` as `${string}.${number}`}
					render={({ field }) => <input {...field} type="hidden" />}
				/>
				<Controller
					control={control}
					defaultValue={`${programAnswer.sessionDetailForm.ratedParticipantId}`}
					name={`feedback.${index}.rated_participant_id` as `${string}.${number}`}
					render={({ field }) => <input {...field} type="hidden" />}
				/>
				<div>
					<span className="text-base font-medium text-gray-900">{question.title}</span>
					{question.required && <span className="text-sm leading-4 text-red-500"> *</span>}
					<div className="pb-2 text-gray-600">{question.description}</div>
					{answerField(question, index, control, feedback)}
				</div>
				{errors.feedback?.[index]?.text && (
					<p className="mb-2 pt-1 text-xs leading-4 font-normal text-red-500 not-italic">
						{errors.feedback?.[index].text.message}
					</p>
				)}
				{errors.feedback?.[index]?.value && (
					<p className="mb-2 pt-1 text-xs leading-4 font-normal text-red-500 not-italic">
						{errors.feedback?.[index].value.message}
					</p>
				)}
			</div>
		);
	});
}

export function showQuestion(programQuestion: ProgramQuestionInterface[], programAnswer: SessionFeedbackAnswerInterface) {
	return programQuestion.map((question: ProgramQuestionInterface) => {
		const feedback = programAnswer.sessionFeedbackForm.feedback.find((answer) => answer.question_id === question.id);
		return (
			<div className="feedback-session-form-mobile min-w-0" key={question.id}>
				<span className="text-base font-medium text-gray-900">{question.title}</span>
				{question.required && <span className="text-sm leading-4 text-red-500"> *</span>}
				<div className="pb-2 text-gray-600">{question.description}</div>
				{ShowAnswer(question, feedback)}
			</div>
		);
	});
}

export function ShowSubmittedFeedback(programAnswer: any) {
	return programAnswer.sessionFeedbackForm.feedback.map((question: any, index: number) => (
		<div className="feedback-session-form-mobile min-w-0" key={index}>
			<span className="text-base font-medium text-gray-900">{question.title}</span>
			{question.required && <span className="text-sm leading-4 text-red-500"> *</span>}
			<div className="pb-2 text-gray-600">{question.description}</div>
			{ShowSubmittedAnswer(question)}
		</div>
	));
}
